import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const Picture = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="0 0 17 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.57054 8.51067L9.53889 6.0009C9.55808 5.97667 9.58249 5.9571 9.61032 5.94364C9.63814 5.93018 9.66864 5.92319 9.69955 5.92319C9.73045 5.92319 9.76096 5.93018 9.78878 5.94364C9.8166 5.9571 9.84102 5.97667 9.8602 6.0009L13.3137 10.4031C13.4174 10.5347 13.3238 10.7295 13.1543 10.7295H3.84637C3.80848 10.7296 3.77134 10.719 3.73918 10.6989C3.70702 10.6789 3.68115 10.6502 3.66452 10.6162C3.64789 10.5821 3.64118 10.5441 3.64516 10.5064C3.64913 10.4687 3.66362 10.4329 3.68698 10.4031L6.21193 7.18494C6.23086 7.16075 6.25505 7.14119 6.28267 7.12773C6.31029 7.11428 6.3406 7.10728 6.37132 7.10728C6.40204 7.10728 6.43236 7.11428 6.45997 7.12773C6.48759 7.14119 6.51178 7.16075 6.53071 7.18494L7.57054 8.51067Z"
          fill="currentColor"
        />
        <path
          d="M4.94985 5.01886C4.76007 4.82907 4.65345 4.57166 4.65345 4.30326C4.65345 4.03486 4.76007 3.77746 4.94985 3.58767C5.13964 3.39788 5.39705 3.29126 5.66545 3.29126C5.93385 3.29126 6.19126 3.39788 6.38104 3.58767C6.57083 3.77746 6.67745 4.03486 6.67745 4.30326C6.67745 4.57166 6.57083 4.82907 6.38104 5.01886C6.19126 5.20864 5.93385 5.31527 5.66545 5.31527C5.39705 5.31527 5.13964 5.20864 4.94985 5.01886Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.375 2.01074C0.375 1.32039 0.934644 0.760742 1.625 0.760742H15.375C16.0654 0.760742 16.625 1.32039 16.625 2.01074V12.0107C16.625 12.7011 16.0654 13.2607 15.375 13.2607H1.625C0.934644 13.2607 0.375 12.7011 0.375 12.0107V2.01074ZM1.625 2.01074H15.375V12.0107H1.625L1.625 2.01074Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)
export default Picture
